import React, { useState } from "react";
import { useNavigate } from "react-router";
import Input from "@mui/joy/Input";
import "../Welcome/WelcomePage.css";
import "./Register.css";
import axios from "axios";
import theme from "../../themes/theme";
import { ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";

import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import BASE_URL from "../../config/api";

export default function Register() {
  const navigate = useNavigate();
  const [passwordError, setPasswordError] = useState("");
  const isPasswordValid = (password) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
    return passwordRegex.test(password);
  };

  const [userInput, setUserInput] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    city: "",
    image: null,
    walletAddress: "",
  });
  const [message, setMessage] = useState("");
  const [incorrectStyles, setIncorrectStyles] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const colorMessage = incorrectStyles ? "#f00" : "#000";

  async function RegisterUser(data) {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("surname", data.surname);
      formData.append("email", data.email);
      formData.append("password", data.password);
      formData.append("city", data.city);
      formData.append("walletAddress", data.walletAddress);
      if (data.image) {
        formData.append("image", data.image);
      }

      await axios.post(`${BASE_URL}/register`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      // const userInfo = await user.data;
      // console.log(userInfo);
      setIncorrectStyles(false);
      setIsSuccess(true);
      setMessage("You are successfully registered!");
      setUserInput({
        name: "",
        surname: "",
        email: "",
        password: "",
        city: "",
        image: null,
        walletAddress: "",
      });
    } catch (err) {
      console.log(err.response.data);
      // toast.error(err.response.data.error.split(","));
      toast.error(err.response.data.error.split(",")[0].replace(/name:|surname:|city:|email:|password:/g, ""));
      // toast.error("Please fill in all required fields correctly.");
      setIsSuccess(false);
      setIncorrectStyles(true);
      setMessage(err.response ? err.response.data.err : err.message);
    }
  }

  function handleClick(e) {
    e.preventDefault();
    RegisterUser(userInput);
  }

  function handleRouting() {
    navigate("/login");
  }

  function handleCancel() {
    navigate("/");
  }

  return (
    <div className="register-wrapper">
      {isSuccess ? (
        <div className="container-succes">
          <h2 style={{ textAlign: "center", color: colorMessage }}>{message && message}</h2>
          <ThemeProvider theme={theme}>
            <Button variant="contained" onClick={handleRouting}>
              Click here to log in
            </Button>
          </ThemeProvider>
        </div>
      ) : (
        <form className="form-wrapper">
          <p className="register-title">Create your profile</p>

          <div className="box">
            <div className="left-c">
              <label>Your name</label>
              <Input
                variant="soft"
                required
                type="text"
                placeholder="Name"
                name="name"
                value={userInput.name}
                onChange={(e) =>
                  setUserInput((prev) => ({
                    ...prev,
                    name: e.target.value,
                  }))
                }
              ></Input>
              <label>Your surname</label>
              <Input
                variant="soft"
                required
                type="text"
                placeholder="Surname"
                name="surname"
                value={userInput.surname}
                onChange={(e) =>
                  setUserInput((prev) => ({
                    ...prev,
                    surname: e.target.value,
                  }))
                }
              ></Input>
              <label>Email address</label>
              <Input
                variant="soft"
                type="email"
                className="rInput"
                value={userInput.email}
                onChange={(e) =>
                  setUserInput((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                placeholder="Enter Email"
                name="email"
                required
              ></Input>
              <label>Password</label>
              <Input
                variant="soft"
                placeholder="Enter Password"
                className={`rInput ${passwordError && "error"}`}
                type="password"
                name="password"
                value={userInput.password}
                onChange={(e) => {
                  setUserInput((prev) => ({
                    ...prev,
                    password: e.target.value,
                  }));
                  setPasswordError("");
                }}
                onFocus={() => {
                  setPasswordError("Password should have at least 8 characters, one uppercase letter, one numeric digit, and one special character.");
                }}
                onBlur={() => {
                  const password = userInput.password;
                  if (!isPasswordValid(password)) {
                    setPasswordError("Password should have at least 8 characters, one uppercase letter, one numeric digit, and one special character.");
                  } else {
                    setPasswordError("");
                  }
                }}
                required
              ></Input>
              {passwordError && (
                <p style={{ fontSize: "10px" }} className="error-message">
                  {passwordError}
                </p>
              )}
              <div></div>
              <label>City you are coming from</label>
              <Input
                variant="soft"
                type="email"
                className="rInput"
                value={userInput.city}
                onChange={(e) =>
                  setUserInput((prev) => ({
                    ...prev,
                    city: e.target.value,
                  }))
                }
                placeholder="Enter City"
                name="email"
                required
              ></Input>
            </div>
            <div className="rigt-c">
              {/* <FormControl
                variant="filled"
                sx={{
                  margin: "20px 0",
                  width: "100%",
                }}
              >
                <InputLabel id="select-label">City you are coming from</InputLabel>
                <Select
                  required
                  sx={{
                    backgroundColor: " #F0F4F8",
                    padding: "10px",
                    textAlign: "left",
                  }}
                  labelId="select-label"
                  id="demo-simple-select-standard"
                  value={userInput.city}
                  label="Select"
                  onChange={(e) =>
                    setUserInput((prev) => ({
                      ...prev,
                      city: e.target.value,
                    }))
                  }
                >
                  {cities.map((city, index) => (
                    <MenuItem key={index} value={city.name}>
                      {city.name}
                    </MenuItem>
                  ))}
                  <MenuItem>Other</MenuItem>
                </Select>
              </FormControl> */}
              {/* <label>Upload Profile Image (JPG only)</label>

              <ImageUploadPreview
                imageUrl={userInput.image}
                onImageChange={(file) =>
                  setUserInput((prev) => ({
                    ...prev,
                    image: file,
                  }))
                }
              /> */}
            </div>
          </div>
          <div className="register-btns">
            <ThemeProvider theme={theme}>
              <Button variant="contained" onClick={handleClick}>
                Create profile
              </Button>
              <Button variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>
            </ThemeProvider>
          </div>
          <p style={{ textAlign: "center", color: colorMessage }}>{message && message}</p>
          <ToastContainer position="bottom-right" autoClose={3000} hideProgressBar />
        </form>
      )}
    </div>
  );
}
